import { createRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { Route as RootRoute } from './__root';

const PujcovnaSmlouvaTisk = lazy(() =>
  import('@/modules/pujcovna/PujcovnaSmlouvaTisk').then((m) => ({ default: m.PujcovnaSmlouvaTisk })),
);

export const Route = createRoute({
  getParentRoute: () => RootRoute,
  path: '/pujcovna/rezervace/$id/smlouva',
  component: () => (
    <Suspense fallback={null}>
      <PujcovnaSmlouvaTisk />
    </Suspense>
  ),
});
